/**
 * Zobrazované názvy oddelení. V databáze sú kódy (REGIONALNY_VEDUCI…), v rozhraní ich ukazujeme po slovensky.
 */
export const ODDELENIE_LABELS = {
  MANAZMENT: 'Manažment',
  PRODUKCIA: 'Produkcia',
  MARKETING: 'Marketing',
  FINANCIE: 'Financie',
  PERSONALNE: 'Personálne',
  IT: 'IT',
  RIADITEL: 'Riaditeľ',
  REGIONALNY_VEDUCI: 'Regionálny vedúci',
  PREVADZKA: 'Prevádzka',
  VSETKY: 'Všetky oddelenia',
}

/** Názov oddelenia pre rozhranie; neznámy kód sa zobrazí ako veta („NOVE_ODDELENIE“ → „Nove oddelenie“). */
export function oddelenieLabel(code) {
  if (!code) return ''
  if (ODDELENIE_LABELS[code]) return ODDELENIE_LABELS[code]
  const text = String(code).replace(/_/g, ' ').toLowerCase()
  return text.charAt(0).toUpperCase() + text.slice(1)
}

/** Položky pre v-select: [{ title, value }] v poradí podľa zoznamu kódov. */
export function oddelenieItems(codes) {
  return codes.map((value) => ({ title: oddelenieLabel(value), value }))
}
